import Query from '../../../../../components/Report';

export const query = ({ prompt_uids = [], platforms = '', gsc_domain = '' }) =>
    new Query('ai-tracking-citations-vs-gsc', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
        base_domain: gsc_domain ? setDomain(gsc_domain) : '',
    });

function setKeywordUids(ids) {
    return `prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setPlatforms(platforms) {
    return `and platform in (${platforms.map((item) => `'${item}'`)})`;
}

function setDomain(domain) {
    return `AND (base_domain = NET.REG_DOMAIN('${domain}') or base_domain = NET.HOST('${domain}'))`;
}
